// 接口地址
// const dev_port = 'http://139.196.146.86/finalgear/' //测试环境
// const dev_port ='http://106.15.170.130/finalgear/' //正式环境
const dev_port=process.env.NODE_ENV === 'production' ? 'http://106.15.170.130/finalgear/' : 'http://139.196.146.86/finalgear/';

//测试环境cdn地址
// export const cdn_test='http://ldqtest.ldmnq.com/summer/' //测试环境        
// export const cdn_test='http://192.168.0.61:8081/index.html?share='
export const signin = dev_port + 'rest/signin'
export const Login = dev_port + 'rest/login'
export const is_signin = dev_port + 'rest/is-signin'
export const my_prize = dev_port + 'rest/my-prize'
export const logout = dev_port + 'rest/logout'
export const my_address = dev_port + 'rest/my-address'
export const draw = dev_port + 'rest/draw'
export const quiz_topic = dev_port + 'rest/quiz-topic'
export const fill_qq = dev_port + 'rest/fill-qq'
export const fill_address = dev_port + 'rest/fill-address'
export const is_login = dev_port + 'rest/is-login'
export const my_points = dev_port + 'rest/my-points'
export const quiz_answer = dev_port + 'rest/quiz-answer'
export const award = dev_port + 'rest/award'
export const prize_list = dev_port + 'rest/prize-list'
export const my_word_set = dev_port + 'rest/my-word-set'